import React from 'react';
import { Modal, Button } from '@cityelectricalfactors/ui-components';
import styled from 'styled-components';
import { WarningTriangle } from 'assets/common_svgs';

/**
 * @param {Object} props
 * @param {boolean} props.modalIsOpen - whether the modal is open or not
 * @param {function} props.closeModal - function to close modal
 * @param {function} props.clearAllOrders - function to execute upon clicking Confirm
 * @param {Object} props.content - text to display on the modal
 * @returns confirmation modal
 */
const ConfirmationModal = ({
  modalIsOpen,
  closeModal,
  clearAllOrders,
  content: { head, text, confirm, close },
}) => (
  <StyledModal
    className="confirmation-modal"
    isOpen={modalIsOpen}
    closeModal={closeModal}>
    <div className="confirmation-modal__content fl ai-c">
      <WarningTriangle
        fillColor="#d41f3a"
        height="26"
        width="30"
        cn="confirmation-modal__content--icon mr-8 m-mb-18 mb-40"
      />
      <div className="confirmation-modal__content--text-wrapper fl ai-fs fl-col">
        <h2 className="ff-rc no-mb fw-500 grey-70 fs-22">{head}</h2>
        <p className="ff-r tc-grey-70 no-margin fs-16">{text}</p>
      </div>
    </div>
    <div className="confirmation-modal__buttons fl jc-fe ml-30 mr-45 mt-52">
      <CancelButton
        type="button"
        handleClick={() => closeModal()}
        label="Cancel"
        className="tc-white fw-500 b-none p-0 fs-16 bg-grey-70">
        {close}
      </CancelButton>
      <ConfirmButton
        type="button"
        handleClick={() => clearAllOrders()}
        label="Clear All Orders"
        className="tc-white fw-500 b-none p-0 fs-16 bg-cta-green">
        {confirm}
      </ConfirmButton>
    </div>
  </StyledModal>
);

const StyledModal = styled(Modal)`
  > div {
    width: 70%;
    max-height: 70%;
    overflow: scroll;
    @media only screen and (min-width: 768px) {
      width: 35%;
    }
  }
`;

const CancelButton = styled(Button)`
  width: 43%;
  height: 42px;
  @media only screen and (min-width: 768px) {
    width: 20%;
  }
`;

const ConfirmButton = styled(Button)`
  width: 48%;
  height: 42px;
  margin-left: 15px;
  @media only screen and (min-width: 768px) {
    width: 25%;
  }
`;

export default ConfirmationModal;
